<div (click)="openMenu()" class="nav-more d-none d-lg-flex" role="banner">
  <span class="more-text ml-auto greet">
    {{ (userFirstName$ | async) ? "Good " + getGreetingMsg() + "," : "" }}
    <span class="bold">{{ userFirstName$ | async }}</span>
  </span>
  <img
    src="assets/svg/ico_account.svg"
    alt="More"
    height="20"
    class="mr-3 more-icon nav-button"
    (click)="openMenu()"
    (keyup.enter)="openMenu()"
    tabindex="0"
  />
  <!-- <img
    src="assets/svg/ico_shopping-cart.svg"
    alt="Shopping Cart"
    height="20"
    class="more-icon"
    tabindex="0"
  /> -->
</div>
<div class="nav-mobile d-lg-none" role="navigation">
  <img
    routerLink="/"
    class="logo"
    src="assets/images/cbw-logo.png"
    alt="Camp Bow Wow"
    (click)="logLandingPage()"
  />
  <span class="mobile-icon-container ml-auto nav-button">
    <img
      src="assets/svg/ico_hamburger.svg"
      alt="More"
      width="28"
      class="nav-button"
      (click)="openMenu()"
      tabindex="0"
    />
  </span>
  <!-- <span class="mobile-icon-container">
    <img
      src="assets/svg/ico_shopping-cart_red.svg"
      alt="Shopping Cart"
      width="28"
    />
  </span> -->
</div>
<div *ngIf="isMenuOpen" id="navMenu" class="nav-menu" role="navigation">
  <ul class="menu-section-container d-lg-none">
    <li>
      <a
        class="nav-menu-link"
        routerLink="/"
        (click)="logLandingPage()"
      >Home</a
      >
    </li>
    <li>
      <a
        class="nav-menu-link"
        routerLink="/camper-cams"
        (click)="logCamperCams()"
        >Camper Cams<sup>&#8480;</sup></a
      >
    </li>
    <li>
      <a
        class="nav-menu-link"
        routerLink="/upcoming-bookings"
        (click)="logUpcoming()"
        >Upcoming</a
      >
    </li>
    <li>
      <a class="nav-menu-link" routerLink="/packages" (click)="logPackages()"
        >Packages</a
      >
    </li>
    <li>
      <a class="nav-menu-link action bold" routerLink="/reservation"
        >Book a Reservation</a
      >
    </li>
  </ul>
  <div class="menu-section-divider d-lg-none"></div>
  <ul class="menu-section-container">
    <li>
      <a
        class="nav-menu-link"
        routerLink="/my-profile"
        (click)="logMoreMyProfile()"
        >My Profile</a
      >
    </li>
    <!--
    <li>
      <a class="nav-menu-link" routerLink="/camper-list" (click)="logCamperList()"
      >My Campers</a
      >
    </li>
    -->
    <li>
      <a
        class="nav-menu-link"
        routerLink="/payments"
        (click)="logMorePayments()"
        >Payments</a
      >
    </li>
    <li>
      <a
        class="nav-menu-link"
        href="https://www.bowwowbuddies.com/"
        target="_blank"
        (click)="logBWB()"
        >Bow Wow Buddies Foundation<sup>&#174;</sup></a
      >
    </li>
    <li>
      <a class="nav-menu-link" routerLink="/preferences" (click)="logComPref()"
        >Communication Preferences</a
      >
    </li>
    <li>
      <a
        class="nav-menu-link"
        href="https://www.campbowwow.com/"
        target="_blank"
        (click)="logLegal()"
        >Legal</a
      >
    </li>
    <li>
      <a
        class="nav-menu-link"
        routerLink="/change-password"
        (click)="logChangePassword()"
        >Change Password</a
      >
    </li>
    <li>
      <a
        class="nav-menu-link"
        href="https://www.campbowwow.com/about-us/faqs/account"
        target="_blank"
        (click)="logHelp()"
      >Help</a
      >
    </li>
  </ul>
  <div class="menu-section-divider alt"></div>
  <div class="menu-section-container alt">
    <a class="nav-menu-link alt" tabindex="0" (click)="logout()">Log Out</a>
  </div>
</div>
<div id="navMain" class="nav-main d-none d-lg-flex" role="navigation">
  <a routerLink="/">
    <img
      id="logo"
      class="logo"
      src="assets/images/cbw-logo.png"
      alt="Camp Bow Wow"
    />
  </a>
  <ul class="d-flex ml-auto bold">
    <li>
      <a class="nav-link" routerLink="/" (click)="logLandingPage()"
      >Home</a
      >
    </li>
    <li>
      <a class="nav-link" routerLink="/camper-cams" (click)="logCamperCams()"
        >Camper Cams<sup>&#8480;</sup></a
      >
    </li>
    <li>
      <a
        class="nav-link"
        routerLink="/upcoming-bookings"
        (click)="logUpcoming()"
        >Upcoming</a
      >
    </li>
    <li>
      <a class="nav-link" routerLink="/packages" (click)="logPackages()"
        >Packages</a
      >
    </li>
  </ul>
  <button
    id="bookBtn"
    class="btn btn-danger book-btn"
    routerLink="/reservation"
    (click)="logReservation()"
    style="margin-left: 1.25rem"
  >
    Book a Reservation
  </button>
</div>
